module.exports = __webpack_public_path__ + "static/img/main_small_bg1.9c5d5f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/main_small_bg1.png
// module id = 83yw
// module chunks = 1